import { combineReducers } from 'redux';

import { IAction, IState } from 'shared/interface/state';

import loadingReducer from './loadingReducer';
import authReducer, { initialState } from 'features/auth/store/reducer';
import makePickReducer, { initialMakePickState } from './makePickChooseReducer';

const appReducer = combineReducers({
	loading: loadingReducer,
	auth: authReducer,
	makePickChoose: makePickReducer
});

const rootReducer = (state: IState | undefined, action: IAction) => {
	if (action.type === 'LOGOUT') {
		state = undefined;
	}
	return appReducer(state, action);
};

export default rootReducer;

export const initialStore: RootState = {
	auth: initialState,
	loading: { api: { isLoading: false } },
	makePickChoose: initialMakePickState
};
export type RootState = ReturnType<typeof appReducer> | undefined;
